import compareArrays from "./compareArrays";

export default function compareObjects(
  objectOne: { [key: string]: any },
  objectTwo: { [key: string]: any }
): boolean {
  const keysOne = Object.keys(objectOne);
  const keysTwo = Object.keys(objectTwo);

  if (keysOne.length !== keysTwo.length) {
    return false;
  }

  for (const key of keysOne) {
    const valueOne = objectOne[key];
    const valueTwo = objectTwo[key];

    if (typeof valueOne === "object" && typeof valueTwo === "object") {
      if (Array.isArray(valueOne) && Array.isArray(valueTwo)) {
        if (!compareArrays(valueOne, valueTwo)) {
          return false;
        }
      } else {
        if (!compareObjects(valueOne, valueTwo)) {
          return false;
        }
      }
    } else {
      if (valueOne !== valueTwo) {
        return false;
      }
    }
  }

  return true;
}
